import { render, staticRenderFns } from "./BnDate.vue?vue&type=template&id=d5b83398&"
import script from "./BnDate.vue?vue&type=script&lang=js&"
export * from "./BnDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports